import { getStorage, setStorage } from '../helpers/storage';
export function initWcag() {
    const wcagEls = document.querySelectorAll('.wcag');
    if (!wcagEls?.length)
        return;
    initDarkMode(wcagEls);
    initFontSize(wcagEls);
}
function updateIframeWcag(setting) {
    document.querySelectorAll('iframe')?.forEach((iframe) => {
        if (iframe.contentWindow) {
            iframe.contentWindow.postMessage(setting, '*');
        }
    });
}
function initDarkMode(wcagEls) {
    const darkMode = localStorage.getItem('darkmode');
    const darkmodeOn = () => {
        document.documentElement.setAttribute('data-darkmode', 'on');
        localStorage.setItem('darkmode', 'on');
        updateIframeWcag({ darkMode: 'on' });
    };
    const darkmodeOff = () => {
        document.documentElement.setAttribute('data-darkmode', 'off');
        localStorage.setItem('darkmode', 'off');
        updateIframeWcag({ darkMode: 'off' });
    };
    function changeMode() {
        let darkMode = localStorage.getItem('darkmode');
        darkMode === 'on'
            ? darkmodeOff()
            : darkmodeOn();
    }
    wcagEls.forEach(wcag => {
        const contrastBtn = wcag.querySelector('.wcag-contrast');
        contrastBtn.addEventListener('click', changeMode);
    });
    if (darkMode === 'on') {
        darkmodeOn();
    }
}
function initFontSize(wcagEls) {
    const size = getStorage('fontsize');
    const html = document.querySelector('html');
    const enableSizeMinus = () => {
        html.className = 'fontsize-1 transition';
        setStorage('fontsize', 0);
        updateIframeWcag({ fontSize: '0' });
    };
    const enableSizePlus = () => {
        html.className = 'fontsize-2 transition';
        setStorage('fontsize', 1);
        updateIframeWcag({ fontSize: '1' });
    };
    wcagEls.forEach(wcag => {
        const btnMinus = wcag.querySelector('.wcag-font-minus');
        const btnPlus = wcag.querySelector('.wcag-font-plus');
        btnMinus.addEventListener('click', enableSizeMinus);
        btnPlus.addEventListener('click', enableSizePlus);
    });
    if (size == '0') {
        enableSizeMinus();
    }
    else if (size == '1') {
        enableSizePlus();
    }
}
